import { SVGS } from '../../SVG/SVGS.js';
/** Application Config
    @description Contains application specific settings
    @important The contents of this file are publically available. Avoid adding sensitive values
*/
export const CONFIG = {
    app: {
        id: 1,
        name: 'EthicsFormApp',
        label: 'ClaimSecure',
        icon: 'LOGO_CLAIMSECURE',
        version: '0.9.1.1',
        author: 'Ryan Dunphy',
        lastModified: '2026-01-08',
        console: {
            debug: true,
            info: true,
            warn: true,
            error: true
        },
        recursionLimit: 100,
        // apiEndpoint: 'http://10.52.4.219:8090'
        apiEndpoint: 'https://cls.api.ethics.spoonmedia.dev'
    },
    user: {
        username: 'Guest',
        avatar: '/images/user256.png',
        role: ''
    },
    event: {
        LongClick: {
            delay: 2000
        }
    },
    css: {
        TransitionSpeed: 100,
        LongclickDelay: 2000
    },
    layout: {
        ratio: {
            '1': {
                width: 1024
            },
            '3': {
                width: 2048
            }
        },
        mobile: {
            minWidth: 400,
            maxWidth: 1100,
            pixelRatio: 3
        },
        desktop: {
            minWidth: 1024,
            maxWidth: 1920,
            pixelRatio: 1
        },
        ultrawide: {
            minWidth: 1921,
            maxwidth: 9999,
            pixelRatio: 1
        }
    },
    translation: {
        // apiEndpoint: 'http://10.52.4.219:8090',
        apiEndpoint: 'https://cls.api.ethics.spoonmedia.dev',
        lastModified: '2026-01-05',
        translatable: [],
        language: {
            code: window.sessionStorage.getItem('language') || 'ca-en',
            id: ''
        },
        languages: [],
        groupKey: ['EthicsHotline', 'Month', 'Day', 'UI', 'EthicalBreachType', 'EthicalBreachTypeSummary'],
        groups: {},
        textgroups: {},
        text: {
            'ca-en': {},
            'ca-fr': {}
        }
    },
    auth: {
        'url': {
            //'login': 'https://keycloak.spoonmedia.net/realms/spoonmedia/protocol/openid-connect/token',
            'login': 'https://cls.api.ethics.spoonmedia.dev/auth/jwt/login',
            'logout': 'https://cls.api.ethics.spoonmedia.dev/auth/jwt/logout',
            'validate': 'https://cls.api.ethics.spoonmedia.dev/auth/jwt/validate',
            'refresh': 'https://cls.api.ethics.spoonmedia.dev/auth/jwt/refresh',
            'user': 'https://cls.api.ethics.spoonmedia.dev/elements/auth/user/'
        }
    },
    page: {
        loginDisabled: false,
        panes: [
            {
                id: 1,
                name: 'PANELOADER_HOME',
                label: 'Ethics',
                role: [],
                icon: SVGS.ETHICS_48PX,
                children: [
                    {
                        id: '1',
                        name: 'index',
                        label: 'Report A Breach',
                        role: [],
                        translation: {
                            groupKey: ['EthicsHotline', 'Month', 'Day']
                        },
                        icon: SVGS.SPEAKUP_48PX,
                        children: []
                        // 	{
                        // 		id: '1-1',
                        // 		name: 'index-1',
                        // 		label: 'One',
                        // 		icon: SVGS.HOME,
                        // 		children: []
                        // 	},
                        // 	{
                        // 		id: '1-2',
                        // 		name: 'index-2',
                        // 		label: 'Two',
                        // 		icon: SVGS.HOME,
                        // 		children: []
                        // 	}
                        // ]
                    },
                    // {
                    // 	id: '2',
                    // 	name: 'conduct',
                    // 	label: 'Code of Conduct',
                    // 	icon: SVGS.PANELS_STROKE,
                    // 	children: []
                    // },
                    {
                        id: '3',
                        name: 'review',
                        label: 'Review Breach',
                        role: ['Admin'],
                        translation: {
                            groupKey: ['EthicsHotline', 'Month', 'Day']
                        },
                        icon: SVGS.DOC,
                        children: []
                    },
                    {
                        id: '4',
                        name: 'list',
                        label: 'List Breaches',
                        role: ['Admin'],
                        translation: {
                            groupKey: ['EthicsHotline', 'Month', 'Day']
                        },
                        icon: SVGS.DOC,
                        children: []
                    },
                ]
            }
        ]
    }
};
